module.exports = __webpack_public_path__ + "img/13.2c384f9a.png";